import type { AuthPermissionUser, UserRole } from '../../services/authPermissions';
import { hasUserRole } from '../../services/authPermissions';

export const GLOBAL_COMMUNICATION_ROLES: UserRole[] = ['ADMIN'];

export function canViewGlobalCommunications(
  user: AuthPermissionUser | null | undefined,
): boolean {
  return hasUserRole(user, GLOBAL_COMMUNICATION_ROLES);
}
